/**
 *
 * FormControlOption
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import _classNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';

const useStyles = makeStyles(theme => ({
  formControlLabelRoot: {
    marginTop: 6,
    padding: '4px 0',
    alignItems: 'flex-start',
    '&:first-child': {
      marginTop: 0,
    },
    [theme.breakpoints.down('600')]: {
      padding: '4px 0',
      '&:first-child': {
        marginTop: 4,
      },
    },
  },
  formControlLabelRootSelected: {
    background: '#EBF2F7',
    borderRadius: 4,
  },
  formControlLabel: {
    ...theme.typography.body2,
    display: 'block',
    [theme.breakpoints.down('xs')]: {
      lineHeight: '1.43',
    },
  },
  root: {
    padding: '0 4px',
    display: 'flex',
    alignItems: 'flex-start',
    '& svg': {
      width: '0.9em',
      height: '0.9em',
      [theme.breakpoints.down('xs')]: {
        width: '1.2em',
        height: '1.2em',
      },
    },
    '&:hover': {
      backgroundColor: 'transparent !important',
    },
  },
}));

function FormControlOption({ checked, label, type, value, onChange }) {
  const classes = useStyles();

  let control;
  if (type === 'radio') {
    control = (
      <Radio
        color="primary"
        checked={checked}
        classes={{ root: classes.root }}
        disableRipple
      />
    );
  } else {
    control = (
      <Checkbox
        checked={checked}
        onChange={onChange}
        value={value}
        color="primary"
        inputProps={{ 'aria-label': `Checkbox ${value}` }}
        classes={{ root: classes.root }}
        disableRipple
      />
    );
  }
  return (
    <FormControlLabel
      value={value}
      control={control}
      label={label}
      classes={{
        root: _classNames(classes.formControlLabelRoot, {
          [classes.formControlLabelRootSelected]: checked,
        }),
        label: classes.formControlLabel,
      }}
    />
  );
}

FormControlOption.propTypes = {
  checked: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  type: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default FormControlOption;
